export default "__VITE_ASSET__99c5888b__"